import { default as _91_46_46_46slug_9391rlTG9ku1Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/[...slug].vue?macro=true";
import { default as indexKsyc7xMURcMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/auth/index.vue?macro=true";
import { default as indexrsv2XIIBXlMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/auth/social/[organisation]/[provider]/index.vue?macro=true";
import { default as _91id_93Dhmaj4n5dfMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/formProcess/[id].vue?macro=true";
import { default as _91id_93yca9y2hvmLMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/formProcess/success/[id].vue?macro=true";
import { default as _91region_93hDYCREpMJMMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/jugend-zaehlt/[region].vue?macro=true";
import { default as _91slug_93sRfE325NUIMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/news/[slug].vue?macro=true";
import { default as organisationstbCVlQ3suKMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/organisations.vue?macro=true";
import { default as grouped_45by_45eventsbUZixxv9cZMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/processes/index/grouped-by-events.vue?macro=true";
import { default as grouped_45by_45funding_45programsfVDu2jU2FiMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/processes/index/grouped-by-funding-programs.vue?macro=true";
import { default as indexlikIF0C7VGMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/processes/index.vue?macro=true";
import { default as dungeonmnsvVYTGbPMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/secret/index/dungeon.vue?macro=true";
import { default as inputsOt3f3fSQWXMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/secret/index/inputs.vue?macro=true";
import { default as indexH11HjZbAUFMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/secret/index.vue?macro=true";
import { default as indexqvpuxUOcJ6Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/categories/index.vue?macro=true";
import { default as formBaseDataIiRVdBDZ0oMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/forms/[id]/formBaseData.vue?macro=true";
import { default as formClassrpDEBgEy9jMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/forms/[id]/formClass.vue?macro=true";
import { default as _91id_93618zN3UOqnMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/forms/[id].vue?macro=true";
import { default as indexlyeOUxcr8VMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/forms/index.vue?macro=true";
import { default as fundingProgramBaseDataRvBmMpQuG2Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue?macro=true";
import { default as fundingProgramProcessFieldsgBHHp01D7bMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue?macro=true";
import { default as fundingProgramReportsmu2KBo7s3qMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue?macro=true";
import { default as fundingProgramRightsJAZLpWxQIHMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue?macro=true";
import { default as _91id_93wJ7n7GxvgzMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/fundingPrograms/[id].vue?macro=true";
import { default as index7EeJJL6jsSMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/fundingPrograms/index.vue?macro=true";
import { default as mailActivitiesxRNx9ABF2qMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mails/[id]/mailActivities.vue?macro=true";
import { default as mailBaseDataRRiOik7tqSMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mails/[id]/mailBaseData.vue?macro=true";
import { default as _91id_93v6q5paRyD4Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mails/[id].vue?macro=true";
import { default as indexgX6ZVEd0ndMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mails/index.vue?macro=true";
import { default as mailTemplateActivitiesvTJYMTYOY4Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue?macro=true";
import { default as mailTemplateBaseDatadxoJhTwx9nMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue?macro=true";
import { default as _91id_93zvZR5hrCDFMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mailTemplates/[id].vue?macro=true";
import { default as indexjJa0VxJW8VMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mailTemplates/index.vue?macro=true";
import { default as roleBaseDataflxmIczoy9Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/roles/[name]/roleBaseData.vue?macro=true";
import { default as _91name_93zF7CKYGX9uMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/roles/[name].vue?macro=true";
import { default as index8hqm7aefsbMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/roles/index.vue?macro=true";
import { default as statisticFormBaseDataQ8lHTkZQ98Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue?macro=true";
import { default as statisticFormClassiQ2HIbR0tCMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue?macro=true";
import { default as statisticFormDedicatedForms0QZYBEJCsEMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue?macro=true";
import { default as _91id_930RfyXOqbH4Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticForms/[id].vue?macro=true";
import { default as index2YnobWFY7gMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticForms/index.vue?macro=true";
import { default as statisticSurveyActivitiessHCQ6P1DZDMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue?macro=true";
import { default as statisticSurveyBaseDataXpBriYftGNMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue?macro=true";
import { default as statisticSurveyPeriodsreH8yAQ2sLMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue?macro=true";
import { default as _91id_93yrVF9FgDszMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticSurveys/[id].vue?macro=true";
import { default as index3Ii84pSDyhMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticSurveys/index.vue?macro=true";
import { default as statusActivities4ZCO1RTOhCMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statuses/[id]/statusActivities.vue?macro=true";
import { default as statusBaseData1qaAztp7FeMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statuses/[id]/statusBaseData.vue?macro=true";
import { default as statusNotifications8TkWv7MLS9Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statuses/[id]/statusNotifications.vue?macro=true";
import { default as _91id_93tHL0IaNfeeMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statuses/[id].vue?macro=true";
import { default as index2KXTVKAgk1Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statuses/index.vue?macro=true";
import { default as yearBaseDataF8uhpgf5KnMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/years/[id]/yearBaseData.vue?macro=true";
import { default as yearDatarqsUCbSTA1Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/years/[id]/yearData.vue?macro=true";
import { default as _91id_93Jb2LnAFYH3Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/years/[id].vue?macro=true";
import { default as indexggpRVAzF7DMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/years/index.vue?macro=true";
import { default as basicData6DgxPHeubQMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData.vue?macro=true";
import { default as _91id_93YNV9ckbxyKMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/formProcesses/[id].vue?macro=true";
import { default as indexZI6OYdV8e0Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/index.vue?macro=true";
import { default as parishAgeGroups4SYrqYIYojMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue?macro=true";
import { default as parishBaseDatalgkZJJqJYSMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue?macro=true";
import { default as _91id_93wXCHX9BI3tMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/parishes/[id].vue?macro=true";
import { default as indexfapTYdL7aHMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/parishes/index.vue?macro=true";
import { default as parishesZ4OJhttu7cMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/parishes.vue?macro=true";
import { default as regionActivitiesMTu0xrhu7YMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue?macro=true";
import { default as regionAgeGroupsDYqqoxmV2HMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue?macro=true";
import { default as regionBaseDataHSSK0eoBE6Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue?macro=true";
import { default as regionDiaconias5Wd6G8dQZqMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue?macro=true";
import { default as regionParishesODj6r1xTIDMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue?macro=true";
import { default as _91id_93tzoK7EotFyMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/[id].vue?macro=true";
import { default as indexReqBUDNnDEMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/index.vue?macro=true";
import { default as regionsFIbwEOEO33Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions.vue?macro=true";
import { default as jugendzaehltFn1Jf0jbepMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt.vue?macro=true";
import { default as paymentRunBaseDataVxzjCMxBlHMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue?macro=true";
import { default as paymentRunPaymentsos4FA4ol2JMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue?macro=true";
import { default as _91id_93fC6QbRGQAkMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/payments/paymentRuns/[id].vue?macro=true";
import { default as indexQ7e0zOgBIdMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/payments/paymentRuns/index.vue?macro=true";
import { default as payments83MNZI8BxmMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/payments.vue?macro=true";
import { default as processActivitieschlREciE6BMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/processes/[id]/processActivities.vue?macro=true";
import { default as processBaseData6Za4QG8odyMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/processes/[id]/processBaseData.vue?macro=true";
import { default as _91id_93LKHLEiHVsuMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/processes/[id].vue?macro=true";
import { default as indexWcAuurBaWVMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/processes/index.vue?macro=true";
import { default as massApprovalqlQ12H15RgMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/processes/massApproval.vue?macro=true";
import { default as _91id_93X3AC1MUxQaMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/loginProviders/[id].vue?macro=true";
import { default as indexTlaH5ETWtBMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/loginProviders/index.vue?macro=true";
import { default as loginProvidersyDZZyHxAmdMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/loginProviders.vue?macro=true";
import { default as organisationActivitieszaSQprYaBGMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationActivities.vue?macro=true";
import { default as organisationAssociationSettings196rpfnNnQMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue?macro=true";
import { default as organisationBaseDataw9jOA1agJqMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesWxb7nNbNnAMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationEducationalConceptMeNcBkaiggMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue?macro=true";
import { default as organisationTransferAgreementtWT8jytrFoMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsersVQGCki8wulMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93A5jv0aSUVIMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id].vue?macro=true";
import { default as indexP0SMkLfppZMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/index.vue?macro=true";
import { default as organisationsCSWSsc1iZxMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations.vue?macro=true";
import { default as userActivitiesaT7vHmarUrMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users/[id]/userActivities.vue?macro=true";
import { default as userBaseDataXKPEum3HZ0Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userFiltersd2TuxvdBxQMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users/[id]/userFilters.vue?macro=true";
import { default as userSignatureSvX7NztkjYMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93I0iLghN9TCMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users/[id].vue?macro=true";
import { default as indexo9uWp57uiMMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users/index.vue?macro=true";
import { default as usersRhvdzXJD5XMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users.vue?macro=true";
import { default as settingsUBtlCIZWuQMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings.vue?macro=true";
import { default as statisticProcessActivities2ZrTcCKFDGMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue?macro=true";
import { default as statisticProcessBaseDatabLtVkRHK6jMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue?macro=true";
import { default as _91id_93lC1EK152h5Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/statisticProcesses/[id].vue?macro=true";
import { default as indexIIm235X2AjMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/statisticProcesses/index.vue?macro=true";
import { default as serviceLooAZy0kijMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service.vue?macro=true";
import { default as language4ZFnvan655Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/language.vue?macro=true";
import { default as organisationBaseDataiz8DY6XXwDMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as organisationCategoriesHtwBMGF22oMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/organisations/[id]/organisationCategories.vue?macro=true";
import { default as organisationTransferAgreementKTC2UR8ONpMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue?macro=true";
import { default as organisationUsers5QgnZV8HWBMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/organisations/[id]/organisationUsers.vue?macro=true";
import { default as _91id_93CS4k3PvUwlMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/organisations/[id].vue?macro=true";
import { default as userBaseDataeIj0cgSyGCMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/users/[id]/userBaseData.vue?macro=true";
import { default as userSignaturezmTTtGshitMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/users/[id]/userSignature.vue?macro=true";
import { default as _91id_93COGey9BUZaMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/users/[id].vue?macro=true";
import { default as index13TjaXNP2kMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/users/index.vue?macro=true";
import { default as settingsGlFOr6RYYXMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings.vue?macro=true";
import { default as signaturePZpAtrF3xzMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/signature.vue?macro=true";
import { default as sportbizzrjGfQt4RTMMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/sportbizz.vue?macro=true";
import { default as _91id_93Uhth73I7gZMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/statisticProcess/[id].vue?macro=true";
import { default as _91id_93ifnFQxOQGVMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/statisticProcess/success/[id].vue?macro=true";
import { default as indexg6xWteJPVeMeta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/statistics/index.vue?macro=true";
import { default as _91_46_46_46slug_93dAxQdS7Cb9Meta } from "/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/wiki/[...slug].vue?macro=true";
import { default as sportbizzk99AObOvrmMeta } from "@/pages/sportbizz.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_9391rlTG9ku1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/[...slug].vue")
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexKsyc7xMURcMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/auth/index.vue")
  },
  {
    name: "auth-social-organisation-provider",
    path: "/auth/social/:organisation()/:provider()",
    meta: indexrsv2XIIBXlMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/auth/social/[organisation]/[provider]/index.vue")
  },
  {
    name: "formProcess-id",
    path: "/formProcess/:id()",
    meta: _91id_93Dhmaj4n5dfMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/formProcess/[id].vue")
  },
  {
    name: "formProcess-success-id",
    path: "/formProcess/success/:id()",
    meta: _91id_93yca9y2hvmLMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/formProcess/success/[id].vue")
  },
  {
    name: "jugend-zaehlt-region",
    path: "/jugend-zaehlt/:region()",
    meta: _91region_93hDYCREpMJMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/jugend-zaehlt/[region].vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/news/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    meta: organisationstbCVlQ3suKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/organisations.vue")
  },
  {
    name: "processes",
    path: "/processes",
    meta: indexlikIF0C7VGMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/processes/index.vue"),
    children: [
  {
    name: "processes-index-grouped-by-events",
    path: "grouped-by-events",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/processes/index/grouped-by-events.vue")
  },
  {
    name: "processes-index-grouped-by-funding-programs",
    path: "grouped-by-funding-programs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/processes/index/grouped-by-funding-programs.vue")
  }
]
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/secret/index/dungeon.vue")
  },
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/secret/index/inputs.vue")
  }
]
  },
  {
    name: serviceLooAZy0kijMeta?.name,
    path: "/service",
    meta: serviceLooAZy0kijMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service.vue"),
    children: [
  {
    name: "service-basicData",
    path: "basicData",
    meta: basicData6DgxPHeubQMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData.vue"),
    children: [
  {
    name: "service-basicData-categories",
    path: "categories",
    meta: indexqvpuxUOcJ6Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/categories/index.vue")
  },
  {
    name: "service-basicData-forms-id",
    path: "forms/:id()",
    meta: _91id_93618zN3UOqnMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/forms/[id].vue"),
    children: [
  {
    name: "service-basicData-forms-id-formBaseData",
    path: "formBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/forms/[id]/formBaseData.vue")
  },
  {
    name: "service-basicData-forms-id-formClass",
    path: "formClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/forms/[id]/formClass.vue")
  }
]
  },
  {
    name: "service-basicData-forms",
    path: "forms",
    meta: indexlyeOUxcr8VMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/forms/index.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id",
    path: "fundingPrograms/:id()",
    meta: _91id_93wJ7n7GxvgzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/fundingPrograms/[id].vue"),
    children: [
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramBaseData",
    path: "fundingProgramBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramBaseData.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramProcessFields",
    path: "fundingProgramProcessFields",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramProcessFields.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramReports",
    path: "fundingProgramReports",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramReports.vue")
  },
  {
    name: "service-basicData-fundingPrograms-id-fundingProgramRights",
    path: "fundingProgramRights",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/fundingPrograms/[id]/fundingProgramRights.vue")
  }
]
  },
  {
    name: "service-basicData-fundingPrograms",
    path: "fundingPrograms",
    meta: index7EeJJL6jsSMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/fundingPrograms/index.vue")
  },
  {
    name: "service-basicData-mails-id",
    path: "mails/:id()",
    meta: _91id_93v6q5paRyD4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mails/[id].vue"),
    children: [
  {
    name: "service-basicData-mails-id-mailActivities",
    path: "mailActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mails/[id]/mailActivities.vue")
  },
  {
    name: "service-basicData-mails-id-mailBaseData",
    path: "mailBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mails/[id]/mailBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mails",
    path: "mails",
    meta: indexgX6ZVEd0ndMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mails/index.vue")
  },
  {
    name: "service-basicData-mailTemplates-id",
    path: "mailTemplates/:id()",
    meta: _91id_93zvZR5hrCDFMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mailTemplates/[id].vue"),
    children: [
  {
    name: "service-basicData-mailTemplates-id-mailTemplateActivities",
    path: "mailTemplateActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mailTemplates/[id]/mailTemplateActivities.vue")
  },
  {
    name: "service-basicData-mailTemplates-id-mailTemplateBaseData",
    path: "mailTemplateBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mailTemplates/[id]/mailTemplateBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-mailTemplates",
    path: "mailTemplates",
    meta: indexjJa0VxJW8VMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/mailTemplates/index.vue")
  },
  {
    name: "service-basicData-roles-name",
    path: "roles/:name()",
    meta: _91name_93zF7CKYGX9uMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/roles/[name].vue"),
    children: [
  {
    name: "service-basicData-roles-name-roleBaseData",
    path: "roleBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/roles/[name]/roleBaseData.vue")
  }
]
  },
  {
    name: "service-basicData-roles",
    path: "roles",
    meta: index8hqm7aefsbMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/roles/index.vue")
  },
  {
    name: "service-basicData-statisticForms-id",
    path: "statisticForms/:id()",
    meta: _91id_930RfyXOqbH4Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticForms/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticForms-id-statisticFormBaseData",
    path: "statisticFormBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticForms/[id]/statisticFormBaseData.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormClass",
    path: "statisticFormClass",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticForms/[id]/statisticFormClass.vue")
  },
  {
    name: "service-basicData-statisticForms-id-statisticFormDedicatedForms",
    path: "statisticFormDedicatedForms",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticForms/[id]/statisticFormDedicatedForms.vue")
  }
]
  },
  {
    name: "service-basicData-statisticForms",
    path: "statisticForms",
    meta: index2YnobWFY7gMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticForms/index.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id",
    path: "statisticSurveys/:id()",
    meta: _91id_93yrVF9FgDszMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticSurveys/[id].vue"),
    children: [
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyActivities",
    path: "statisticSurveyActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyActivities.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyBaseData",
    path: "statisticSurveyBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyBaseData.vue")
  },
  {
    name: "service-basicData-statisticSurveys-id-statisticSurveyPeriods",
    path: "statisticSurveyPeriods",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticSurveys/[id]/statisticSurveyPeriods.vue")
  }
]
  },
  {
    name: "service-basicData-statisticSurveys",
    path: "statisticSurveys",
    meta: index3Ii84pSDyhMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statisticSurveys/index.vue")
  },
  {
    name: "service-basicData-statuses-id",
    path: "statuses/:id()",
    meta: _91id_93tHL0IaNfeeMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statuses/[id].vue"),
    children: [
  {
    name: "service-basicData-statuses-id-statusActivities",
    path: "statusActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statuses/[id]/statusActivities.vue")
  },
  {
    name: "service-basicData-statuses-id-statusBaseData",
    path: "statusBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statuses/[id]/statusBaseData.vue")
  },
  {
    name: "service-basicData-statuses-id-statusNotifications",
    path: "statusNotifications",
    meta: statusNotifications8TkWv7MLS9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statuses/[id]/statusNotifications.vue")
  }
]
  },
  {
    name: "service-basicData-statuses",
    path: "statuses",
    meta: index2KXTVKAgk1Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/statuses/index.vue")
  },
  {
    name: "service-basicData-years-id",
    path: "years/:id()",
    meta: _91id_93Jb2LnAFYH3Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/years/[id].vue"),
    children: [
  {
    name: "service-basicData-years-id-yearBaseData",
    path: "yearBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/years/[id]/yearBaseData.vue")
  },
  {
    name: "service-basicData-years-id-yearData",
    path: "yearData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/years/[id]/yearData.vue")
  }
]
  },
  {
    name: "service-basicData-years",
    path: "years",
    meta: indexggpRVAzF7DMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/basicData/years/index.vue")
  }
]
  },
  {
    name: "service-formProcesses-id",
    path: "formProcesses/:id()",
    meta: _91id_93YNV9ckbxyKMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/formProcesses/[id].vue")
  },
  {
    name: "service",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/index.vue")
  },
  {
    name: "service-jugendzaehlt",
    path: "jugendzaehlt",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt.vue"),
    children: [
  {
    name: parishesZ4OJhttu7cMeta?.name,
    path: "parishes",
    meta: parishesZ4OJhttu7cMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/parishes.vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id",
    path: ":id()",
    meta: _91id_93wXCHX9BI3tMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/parishes/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-parishes-id-parishAgeGroups",
    path: "parishAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/parishes/[id]/parishAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-parishes-id-parishBaseData",
    path: "parishBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/parishes/[id]/parishBaseData.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-parishes",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/parishes/index.vue")
  }
]
  },
  {
    name: regionsFIbwEOEO33Meta?.name,
    path: "regions",
    meta: regionsFIbwEOEO33Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions.vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id",
    path: ":id()",
    meta: _91id_93tzoK7EotFyMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/[id].vue"),
    children: [
  {
    name: "service-jugendzaehlt-regions-id-regionActivities",
    path: "regionActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/[id]/regionActivities.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionAgeGroups",
    path: "regionAgeGroups",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/[id]/regionAgeGroups.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionBaseData",
    path: "regionBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/[id]/regionBaseData.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionDiaconias",
    path: "regionDiaconias",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/[id]/regionDiaconias.vue")
  },
  {
    name: "service-jugendzaehlt-regions-id-regionParishes",
    path: "regionParishes",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/[id]/regionParishes.vue")
  }
]
  },
  {
    name: "service-jugendzaehlt-regions",
    path: "",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/jugendzaehlt/regions/index.vue")
  }
]
  }
]
  },
  {
    name: "service-payments",
    path: "payments",
    meta: payments83MNZI8BxmMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/payments.vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id",
    path: "paymentRuns/:id()",
    meta: _91id_93fC6QbRGQAkMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/payments/paymentRuns/[id].vue"),
    children: [
  {
    name: "service-payments-paymentRuns-id-paymentRunBaseData",
    path: "paymentRunBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/payments/paymentRuns/[id]/paymentRunBaseData.vue")
  },
  {
    name: "service-payments-paymentRuns-id-paymentRunPayments",
    path: "paymentRunPayments",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/payments/paymentRuns/[id]/paymentRunPayments.vue")
  }
]
  },
  {
    name: "service-payments-paymentRuns",
    path: "paymentRuns",
    meta: indexQ7e0zOgBIdMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/payments/paymentRuns/index.vue")
  }
]
  },
  {
    name: "service-processes-id",
    path: "processes/:id()",
    meta: _91id_93LKHLEiHVsuMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/processes/[id].vue"),
    children: [
  {
    name: "service-processes-id-processActivities",
    path: "processActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/processes/[id]/processActivities.vue")
  },
  {
    name: "service-processes-id-processBaseData",
    path: "processBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/processes/[id]/processBaseData.vue")
  }
]
  },
  {
    name: "service-processes",
    path: "processes",
    meta: indexWcAuurBaWVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/processes/index.vue")
  },
  {
    name: "service-processes-massApproval",
    path: "processes/massApproval",
    meta: massApprovalqlQ12H15RgMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/processes/massApproval.vue")
  },
  {
    name: "service-settings",
    path: "settings",
    meta: settingsUBtlCIZWuQMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings.vue"),
    children: [
  {
    name: loginProvidersyDZZyHxAmdMeta?.name,
    path: "loginProviders",
    meta: loginProvidersyDZZyHxAmdMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/loginProviders.vue"),
    children: [
  {
    name: "service-settings-loginProviders-id",
    path: ":id()",
    meta: _91id_93X3AC1MUxQaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/loginProviders/[id].vue")
  },
  {
    name: "service-settings-loginProviders",
    path: "",
    meta: indexTlaH5ETWtBMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/loginProviders/index.vue")
  }
]
  },
  {
    name: organisationsCSWSsc1iZxMeta?.name,
    path: "organisations",
    meta: organisationsCSWSsc1iZxMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations.vue"),
    children: [
  {
    name: "service-settings-organisations-id",
    path: ":id()",
    meta: _91id_93A5jv0aSUVIMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id].vue"),
    children: [
  {
    name: "service-settings-organisations-id-organisationActivities",
    path: "organisationActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationActivities.vue")
  },
  {
    name: "service-settings-organisations-id-organisationAssociationSettings",
    path: "organisationAssociationSettings",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationAssociationSettings.vue")
  },
  {
    name: "service-settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "service-settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "service-settings-organisations-id-organisationEducationalConcept",
    path: "organisationEducationalConcept",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationEducationalConcept.vue")
  },
  {
    name: "service-settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "service-settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "service-settings-organisations",
    path: "",
    meta: indexP0SMkLfppZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/organisations/index.vue")
  }
]
  },
  {
    name: usersRhvdzXJD5XMeta?.name,
    path: "users",
    meta: usersRhvdzXJD5XMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users.vue"),
    children: [
  {
    name: "service-settings-users-id",
    path: ":id()",
    meta: _91id_93I0iLghN9TCMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users/[id].vue"),
    children: [
  {
    name: "service-settings-users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users/[id]/userActivities.vue")
  },
  {
    name: "service-settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "service-settings-users-id-userFilters",
    path: "userFilters",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users/[id]/userFilters.vue")
  },
  {
    name: "service-settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "service-settings-users",
    path: "",
    meta: indexo9uWp57uiMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/settings/users/index.vue")
  }
]
  }
]
  },
  {
    name: "service-statisticProcesses-id",
    path: "statisticProcesses/:id()",
    meta: _91id_93lC1EK152h5Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/statisticProcesses/[id].vue"),
    children: [
  {
    name: "service-statisticProcesses-id-statisticProcessActivities",
    path: "statisticProcessActivities",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/statisticProcesses/[id]/statisticProcessActivities.vue")
  },
  {
    name: "service-statisticProcesses-id-statisticProcessBaseData",
    path: "statisticProcessBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/statisticProcesses/[id]/statisticProcessBaseData.vue")
  }
]
  },
  {
    name: "service-statisticProcesses",
    path: "statisticProcesses",
    meta: indexIIm235X2AjMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/service/statisticProcesses/index.vue")
  }
]
  },
  {
    name: "settings",
    path: "/settings",
    meta: settingsGlFOr6RYYXMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings.vue"),
    children: [
  {
    name: "settings-language",
    path: "language",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/language.vue")
  },
  {
    name: "settings-organisations-id",
    path: "organisations/:id()",
    meta: _91id_93CS4k3PvUwlMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/organisations/[id].vue"),
    children: [
  {
    name: "settings-organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/organisations/[id]/organisationBaseData.vue")
  },
  {
    name: "settings-organisations-id-organisationCategories",
    path: "organisationCategories",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/organisations/[id]/organisationCategories.vue")
  },
  {
    name: "settings-organisations-id-organisationTransferAgreement",
    path: "organisationTransferAgreement",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/organisations/[id]/organisationTransferAgreement.vue")
  },
  {
    name: "settings-organisations-id-organisationUsers",
    path: "organisationUsers",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/organisations/[id]/organisationUsers.vue")
  }
]
  },
  {
    name: "settings-users-id",
    path: "users/:id()",
    meta: _91id_93COGey9BUZaMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/users/[id].vue"),
    children: [
  {
    name: "settings-users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/users/[id]/userBaseData.vue")
  },
  {
    name: "settings-users-id-userSignature",
    path: "userSignature",
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/users/[id]/userSignature.vue")
  }
]
  },
  {
    name: "settings-users",
    path: "users",
    meta: index13TjaXNP2kMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/settings/users/index.vue")
  }
]
  },
  {
    name: "signature",
    path: "/signature",
    meta: signaturePZpAtrF3xzMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/signature.vue")
  },
  {
    name: "sportbizz",
    path: "/sportbizz",
    meta: sportbizzrjGfQt4RTMMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/sportbizz.vue")
  },
  {
    name: "statisticProcess-id",
    path: "/statisticProcess/:id()",
    meta: _91id_93Uhth73I7gZMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/statisticProcess/[id].vue")
  },
  {
    name: "statisticProcess-success-id",
    path: "/statisticProcess/success/:id()",
    meta: _91id_93ifnFQxOQGVMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/statisticProcess/success/[id].vue")
  },
  {
    name: "statistics",
    path: "/statistics",
    meta: indexg6xWteJPVeMeta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/statistics/index.vue")
  },
  {
    name: "wiki-slug",
    path: "/wiki/:slug(.*)*",
    meta: _91_46_46_46slug_93dAxQdS7Cb9Meta || {},
    component: () => import("/home/forge/develop.oase-bw.de/releases/20250618150914/client/pages/wiki/[...slug].vue")
  },
  {
    name: "sportbizz",
    path: "/index/welcome/p/sportbizz",
    meta: sportbizzk99AObOvrmMeta || {},
    component: () => import("@/pages/sportbizz.vue")
  }
]